import moment from 'moment';
import { find, findLast, forEach, get, isPlainObject } from 'lodash';
import { chargerSessionsRange } from './helper';
import { convertRTMetricsForGraph } from '../store/actions';
import { states } from './states';
import { TELEMETRY_TIME_FORMAT } from '../../../../../common/constants/telemetry';

const CHARGER = { uuid: 'demo-charger-1', name: 'Charger 1' };

const getMetrics = (filters, type) => {
  const isHistorical = type === 'historical';
  const { to, aggregation } = filters;

  let start;
  let end;

  if (isHistorical) {
    end = moment(to, TELEMETRY_TIME_FORMAT);
    start = end.clone().subtract('48', 'hours');
  } else {
    end = moment(to, TELEMETRY_TIME_FORMAT).add('2', 'hours');
    start = end.clone().subtract('6', 'hours');
  }

  const demoInterval = isHistorical ? 60000 : 10000;
  const parts = isHistorical ? [18, 17, 25, 40] : [25, 18, 12, 40];
  const timeout = isHistorical ? 3600000 : 600000;

  const metrics = chargerSessionsRange({
    start: +start.format(TELEMETRY_TIME_FORMAT),
    end: +end.format(TELEMETRY_TIME_FORMAT),
    interval: demoInterval,
    aggregation,
    parts,
    timeout,
  });

  return metrics;
};

export const makeSnapshotFromMetrics = (metrics) => {
  let snapshot = null;

  if (isPlainObject(metrics)) {
    const timestamp = new Date().getTime();
    const dates = Object.keys(metrics).sort();

    let element = findLast(dates, (date) => date < timestamp);

    element = get(metrics, element, null);

    if (element) {
      snapshot = find(states, { cableStatus: 'connected' });
      forEach(
        Object.keys(element).filter((metric) => metric.length > 0),
        (metric) => {
          snapshot.session[metric] = element[metric];
        },
      );
    } else {
      snapshot = find(states, { cableStatus: 'disconnected' });
    }
  }

  return snapshot;
};

export const makeLoadMetrics = (filters, { type = 'historical' }) => {
  const metrics = getMetrics(filters, type);
  const metricsData = {};

  Object.values(metrics).forEach(({ ts, metricValues }) => {
    const meterValues = filters ? filters.metrics : Object.keys(metricValues);

    meterValues.forEach((metricCode) => {
      if (!metricsData[metricCode]) {
        metricsData[metricCode] = [];
      }
      metricsData[metricCode].push({
        deviceId: CHARGER.uuid,
        sessionId: 0,
        measure: metricCode,
        ts,
        value: metricValues[metricCode],
      });
    });
  });

  return convertRTMetricsForGraph(CHARGER.uuid, metricsData);
};
